import { IconName } from '../../../components/Icon';

export enum ViewsEnum {
  MONTH = 'month',
}

export enum IncidentTypeKey {
  Holiday = 'Holiday',
  Release = 'Release',
  Operations = 'Operations',
  UserAcquisition = 'User Acquisition',
  Marketing = 'Marketing',
  Outages = 'Outages',
  Other = 'Other',
}

interface IIncidentTypeConfig {
  icon: IconName;
  color: string;
}

export const incidentTypeConfig: Record<IncidentTypeKey, IIncidentTypeConfig> =
  {
    [IncidentTypeKey.Holiday]: {
      icon: 'incident-holiday',
      color: '#33b679',
    },
    [IncidentTypeKey.Release]: {
      icon: 'incident-release',
      color: '#039be5',
    },
    [IncidentTypeKey.Operations]: {
      icon: 'incident-operations',
      color: '#616161',
    },
    [IncidentTypeKey.UserAcquisition]: {
      icon: 'incident-user-acquisition',
      color: '#8e24aa',
    },
    [IncidentTypeKey.Marketing]: {
      icon: 'incident-marketing',
      color: '#0c8043',
    },
    [IncidentTypeKey.Outages]: {
      icon: 'incident-outages',
      color: '#f6bf26',
    },
    [IncidentTypeKey.Other]: {
      icon: 'incident-other',
      color: '#e67d73',
    },
  };
